import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { User, Shield, Award, LogOut, HardHat } from "lucide-react";

export default function FieldProfile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <h1 className="font-head text-4xl font-black text-white">Profile</h1>
      <div className="hw-card hw-glow p-8 text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-gradient-to-br from-cyan-400 to-sky-600 text-slate-900"><HardHat size={36} /></div>
        <div className="mt-4 font-head text-2xl font-bold text-white">{user?.name}</div>
        <div className="hw-eyebrow mt-1">Journeyman Electrician</div>
      </div>

      <div className="space-y-3">
        {[
          { icon: Award, label: "License", value: "NC-EL-44821 · Valid" },
          { icon: Shield, label: "Safety Certs", value: "OSHA 30 · Current" },
          { icon: User, label: "Crew", value: "Foreman: Carlos Nguyen" },
        ].map((r, i) => {
          const Icon = r.icon;
          return (
            <div key={i} className="hw-card flex items-center gap-4 p-5">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-500/10 text-cyan-300"><Icon size={18} /></div>
              <div>
                <div className="hw-eyebrow">{r.label}</div>
                <div className="mt-0.5 font-medium text-white">{r.value}</div>
              </div>
            </div>
          );
        })}
      </div>

      <button onClick={() => { logout(); navigate("/login"); }} className="glove-btn flex w-full items-center justify-center gap-2 border border-rose-500/40 bg-rose-500/10 text-rose-300" data-testid="profile-logout">
        <LogOut size={18} /> Sign Out
      </button>
    </div>
  );
}
